var _rect, _path, _path2, _rect2, _rect3, _rect4, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGeoNongeo = function SvgGeoNongeo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-353 -1148C-353 -1203.23 -308.228 -1248 -253 -1248H31773C31828.2 -1248 31873 -1203.23 31873 -1148V10722C31873 10777.2 31828.2 10822 31773 10822H-253C-308.229 10822 -353 10777.2 -353 10722V-1148Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-253 -1247H31773V-1249H-253V-1247ZM31872 -1148V10722H31874V-1148H31872ZM31773 10821H-253V10823H31773V10821ZM-352 10722V-1148H-354V10722H-352ZM-253 10821C-307.676 10821 -352 10776.7 -352 10722H-354C-354 10777.8 -308.781 10823 -253 10823V10821ZM31872 10722C31872 10776.7 31827.7 10821 31773 10821V10823C31828.8 10823 31874 10777.8 31874 10722H31872ZM31773 -1247C31827.7 -1247 31872 -1202.68 31872 -1148H31874C31874 -1203.78 31828.8 -1249 31773 -1249V-1247ZM-253 -1249C-308.781 -1249 -354 -1203.78 -354 -1148H-352C-352 -1202.68 -307.676 -1247 -253 -1247V-1249Z",
    fill: "black",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1500,
    height: 900,
    transform: "translate(-29 -195)",
    fill: "#F2F2F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 244,
    height: 900,
    transform: "translate(-29 -195)",
    fill: "#F2F2F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -9,
    width: 216,
    height: 40,
    rx: 4,
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91211 13.3552H13.2901M1.91211 13.3552L13.2317 13.3541C13.2513 13.3541 13.2708 13.3545 13.2901 13.3552M1.91211 13.3552L1.91211 17.2404C1.91211 17.7706 2.44937 18.2004 3.11211 18.2004H13.2321C13.8949 18.2004 14.4321 17.7706 14.4321 17.2404V14.3141C14.4321 13.7995 13.9259 13.3794 13.2901 13.3552M1.91211 13.3552L1.91211 8.50861M13.2901 13.3552H18.8881C19.5509 13.3552 20.0881 12.9254 20.0881 12.3952V9.46861C20.0881 8.93842 19.5509 8.50861 18.8881 8.50861M1.91211 8.50861H18.8881M1.91211 8.50861L1.91211 4.76039C1.91211 4.2302 2.44937 3.80039 3.11211 3.80039L7.91211 3.80039C8.57485 3.80039 9.11211 4.2302 9.11211 4.76039V7.54861C9.11211 8.07881 8.57485 8.50861 7.91211 8.50861L18.8881 8.50861M1.91211 20.6004V1.40039",
    stroke: "#797979",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGeoNongeo);
export default ForwardRef;